<section class="page-surface p-6 lg:p-8" [formGroup]="group">
  <h2 *ngIf="requiresAsinValidation"  class="text-lg font-semibold text-slate-700 underline underline-offset-4">
    ASIN Validation
  </h2>

  <div *ngIf="requiresAsinValidation"  class="mt-5 rounded-2xl border border-slate-200 bg-white p-5 lg:p-6">
    <div class="grid gap-5 lg:grid-cols-[1fr_auto] lg:items-end">
      <div class="page-control-group">
        <label class="page-label" for="asin">ASIN <span class="ml-1 text-red-500">*</span></label>
        <input
          id="asin"
          class="page-control"
          type="text"
          placeholder="e.g. 104268290"
          formControlName="asin"
          [class.border-red-300]="hasError('asin')"
        />
        <small *ngIf="hasError('asin')" class="text-xs text-red-500">ASIN is required.</small>
      </div>

      <button
        type="button"
        class="page-btn page-btn-secondary h-[46px] px-6"
        (click)="validateAsin.emit()"
        [disabled]="busyAsin || readOnly"
      >
        @if(busyAsin) {
          <div class="flex items-center gap-2">
            <span
              class="inline-block size-6 animate-spin rounded-full border-4 border-slate-400/80 border-t-white"
              aria-hidden="true"></span>
            <p>
              Validating...
            </p>
          </div>
        } @else {
          Validate
        }
      </button>
    </div>

    <div class="mt-5 grid gap-5 lg:grid-cols-2">
      <div class="page-control-group">
        <label class="page-label" for="vendorName">Vendor Name <span class="ml-1 text-red-500">*</span></label>
        <input
          id="vendorName"
          class="page-control"
          type="text"
          placeholder="Alpha Engineering Ltd"
          formControlName="vendorName"
          [class.border-red-300]="hasError('vendorName')"
        />
        <small *ngIf="hasError('vendorName')" class="text-xs text-red-500"
          >Vendor name is required.</small
        >
      </div>

      <div class="page-control-group">
        <label class="page-label" for="phoneNumber">Phone Number <span class="ml-1 text-red-500">*</span></label>
        <input
          [appCharLength]="11"
          id="phoneNumber"
          class="page-control"
          type="text"
          placeholder="09086635667"
          formControlName="phoneNumber"
          [class.border-red-300]="hasError('phoneNumber')"
        />
        <small *ngIf="hasError('phoneNumber')" class="text-xs text-red-500"
          >Phone number must be 10 to 11 digits.</small
        >
      </div>

      <div class="page-control-group">
        <label class="page-label" for="email">Email <span class="ml-1 text-red-500">*</span></label>
        <input
          [appCharLength]
          id="email"
          class="page-control"
          type="email"
          placeholder="alphaengine@gmail.com"
          formControlName="email"
          [class.border-red-300]="hasError('email')"
        />
        <small *ngIf="hasError('email')" class="text-xs text-red-500"
          >Enter a valid email address.</small
        >
      </div>

      <div class="page-control-group">
        <label class="page-label" for="address">Address <span class="ml-1 text-red-500">*</span></label>
        <input
          id="address"
          class="page-control"
          type="text"
          placeholder="12 parakou street wuse 2 abuja"
          formControlName="address"
          [class.border-red-300]="hasError('address')"
        />
        <small *ngIf="hasError('address')" class="text-xs text-red-500"
          >Address is required.</small
        >
      </div>
    </div>
  </div>

  <h2 class="mt-10 text-lg font-semibold text-slate-700 underline underline-offset-4">
    CAC Verification
  </h2>

  <div class="mt-5 rounded-2xl border border-slate-200 bg-white p-5 lg:p-6">
    <div class="grid gap-5 lg:grid-cols-[1fr_auto] lg:items-end">
      <div class="page-control-group">
        <label class="page-label" for="rcNumber">RC Number <span class="ml-1 text-red-500">*</span></label>
        <input
          id="rcNumber"
          class="page-control"
          type="text"
          placeholder="104268290"
          formControlName="rcNumber"
          [class.border-red-300]="hasError('rcNumber')"
        />
        <small *ngIf="hasError('rcNumber')" class="text-xs text-red-500"
          >RC number is required.</small
        >
      </div>

      <button
        type="button"
        class="page-btn page-btn-secondary h-[46px] px-6"
        (click)="verifyCac.emit()"
        [disabled]="busyCac || readOnly"
      >

      @if(busyCac) {
        <div class="flex items-center gap-2">
          <span
            class="inline-block size-6 animate-spin rounded-full border-4 border-slate-400/80 border-t-white"
            aria-hidden="true"></span>
          <p>
            Verifying...
          </p>
        </div>
      } @else {
        Verify
      }
      </button>
    </div>

    <div class="mt-5 grid gap-5 lg:grid-cols-2">
      <div class="page-control-group">
        <label class="page-label" for="businessClassification">Business Classification <span class="ml-1 text-red-500">*</span></label>
        <input
          id="businessClassification"
          class="page-control"
          type="text"
          placeholder="Company"
          formControlName="businessClassification"
          [class.border-red-300]="hasError('businessClassification')"
        />
        <small *ngIf="hasError('businessClassification')" class="text-xs text-red-500"
          >Business classification is required.</small
        >
      </div>

      <div class="page-control-group">
        <label class="page-label" for="dateOfIncorporation">Date of Incorporation <span class="ml-1 text-red-500">*</span></label>
        <input
          id="dateOfIncorporation"
          class="page-control"
          type="text"
          placeholder="12-Jan-2020"
          formControlName="dateOfIncorporation"
          [class.border-red-300]="hasError('dateOfIncorporation')"
        />
        <small *ngIf="hasError('dateOfIncorporation')" class="text-xs text-red-500"
          >Date of incorporation is required.</small
        >
      </div>

      <div class="page-control-group">
        <label class="page-label" for="tin">TIN <span class="ml-1 text-red-500">*</span></label>
        <input
          id="tin"
          class="page-control"
          type="text"
          placeholder="012345"
          formControlName="tin"
          [class.border-red-300]="hasError('tin')"
        />
        <small *ngIf="hasError('tin')" class="text-xs text-red-500">TIN is required.</small>
      </div>

      <div class="page-control-group">
        <label class="page-label" for="natureOfService">Nature of Service <span class="ml-1 text-red-500">*</span></label>
        <input
          [appCharLength]
          id="natureOfService"
          class="page-control"
          type="text"
          placeholder="e.g. Construction, Supply, Consulting"
          formControlName="natureOfService"
          [class.border-red-300]="hasError('natureOfService')"
        />
        <small *ngIf="hasError('natureOfService')" class="text-xs text-red-500"
          >Nature of service is required.</small
        >
      </div>

      <div class="page-control-group">
        <label class="page-label" for="mdaAssociation">MDA Association <span class="ml-1 text-red-500">*</span></label>
        <select id="mdaAssociation" class="page-select" formControlName="mdaAssociation">
          <option value="" selected>-- Select MDA --</option>
          <option *ngFor="let mda of mdas" [value]="mda.id">{{ mda.name | titlecase}}</option>
        </select>
        <small *ngIf="hasError('mdaAssociation')" class="text-xs text-red-500"
          >Select an MDA association.</small
        >
      </div>

      <div class="page-control-group">
        <label class="page-label" for="contractCategory">Category <span class="ml-1 text-red-500">*</span></label>
        <select id="contractCategory" class="page-select" formControlName="contractCategory">
          <option value="" selected>-- Select Category --</option>
          <option *ngFor="let category of categories" [value]="category.id">{{ category.name }}</option>
        </select>
        <small *ngIf="hasError('contractCategory')" class="text-xs text-red-500"
          >Select a contract category.</small
        >
      </div>

      <div class="page-control-group">
        <label class="page-label" for="vendorType">
          Vendor Type <span class="ml-1 text-red-500">*</span>
        </label>
        <select
          id="vendorType"
          class="page-select"
          formControlName="vendorType"
          [class.border-red-300]="hasError('vendorType')"
        >
          <option value="" selected>-- Select Vendor Type --</option>
          <option value="CONTRACTOR">CONTRACTOR</option>
          <option value="CONSULTANT">CONSULTANT</option>
        </select>
        <small *ngIf="hasError('vendorType')" class="text-xs text-red-500">Vendor type is required.</small>
      </div>
    </div>
  </div>
</section>
